export const celsiusToFahrenheit = (tempCelsius: number): number =>
  Math.round(tempCelsius * 1.8 + 32);
